import { createContext, useContext } from "react";

import { type config } from "~root/config";

export type Config = typeof config;
export const ConfigContext = createContext<Config | undefined>(undefined);

export function useConfig(): Config {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error(
      "Failed to use config context outside of config context provider",
    );
  }
  return ctx;
}
